import type { IPromotionData } from '@/entities';

export * from './types';

import type { AxiosInstance, AxiosResponse } from 'axios';
import type { IApiPromotionResponse, IApiResponse } from '@/services';
import { mapApiPromotion } from '@/mappers';

export class ApiPromotionEndpoint {
  axios: AxiosInstance;
  config: ImportMetaEnv;

  constructor(axiosInstance: AxiosInstance, config: ImportMetaEnv) {
    this.axios = axiosInstance;
    this.config = config;
  }

  async fetchPromotions(
    locale: string,
    accountType: string | undefined,
    account: string | undefined
  ): Promise<IPromotionData[]> {
    const url = `promotions?locale=${encodeURIComponent(locale)}&accountType=${encodeURIComponent(
      accountType || ''
    )}&account=${encodeURIComponent(account || '')}`;

    const response: AxiosResponse<IApiResponse<IApiPromotionResponse[]>> = await this.axios
      .get(url)
      .catch(() => Promise.reject());

    if (response?.data.data) {
      return response.data.data.map((r) => mapApiPromotion(r));
    }

    return Promise.reject();
  }

  async fetchPastPromotions(
    locale: string,
    accountType: string | undefined,
    account: string | undefined
  ): Promise<IPromotionData[]> {
    const url = `promotions/past?locale=${encodeURIComponent(locale)}&accountType=${encodeURIComponent(
      accountType || ''
    )}&account=${encodeURIComponent(account || '')}&pageNumber=1&pageSize=9`;

    const response: AxiosResponse<IApiResponse<{ pagedList: IApiPromotionResponse[] }>> = await this.axios
      .get(url)
      .catch(() => Promise.reject());

    if (response?.data.data) {
      return response.data.data.pagedList.map((r) => mapApiPromotion(r));
    }

    return Promise.reject();
  }
}
